<template>
  <md-button>Zurück zum Dashboard</md-button>
</template>

<script>
export default {
  mounted() {
    let isSuccess =
      this.$route.query.success === "true" ||
      window.location.search.indexOf("success=true") > -1;
    if (window.location.search) {
      window.history.replaceState(
        null,
        undefined,
        location.origin + location.pathname
      );
    }
    // because the api adds the query param before the hash, e.g. http://localhost:8080/?success=true#/suunto
    if (isSuccess) {
      this.$router.replace("/pages/settings").catch(err => {
        console.log(err);
        throw new Error(`Problem handling something: ${err}.`);
      });
      // Tell user he's registered
      this.$notify({
        timeout: 5000,
        message: "Du bist jetzt mit Suunto verbunden!",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
    } else {
      this.$router.replace("/pages/settings").catch(err => {
        console.log(err);
        throw new Error(`Problem handling something: ${err}.`);
      });
      this.$notify({
        timeout: 5000,
        message:
          "Wir haben leider keine Rechte zu deinen Aktivitäten erhalten, bitte versuche es nochmal.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "error"
      });
    }
  }
};
</script>

<style></style>
